import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetSuggestionsQueryVariables = GraphQLTypes.Exact<{
  suggestionsFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.SuggestionsFiltersInput>;
}>;

export type GetSuggestionsQueryResult = { __typename?: 'Query' } & {
  suggestions?: GraphQLTypes.Maybe<
    { __typename?: 'SuggestionConnection' } & {
      nodes: Array<
        { __typename?: 'Suggestion' } & Pick<
          GraphQLTypes.Suggestion,
          | 'id'
          | 'parentEntityId'
          | 'parentEntityType'
          | 'proposedValue'
          | 'rejectionReason'
          | 'status'
          | 'subjectType'
          | 'targetAttribute'
          | 'targetEntityId'
          | 'targetEntityType'
        > & {
            actionedBy?: GraphQLTypes.Maybe<
              { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
            >;
            sources: Array<{ __typename?: 'SuggestionSource' } & Pick<GraphQLTypes.SuggestionSource, 'source' | 'sourceId'>>;
          }
      >;
    }
  >;
};

export const GetSuggestionsDocument = gql`
  query getSuggestions($suggestionsFiltersInput: SuggestionsFiltersInput) {
    suggestions(suggestionsFiltersInput: $suggestionsFiltersInput) {
      nodes {
        actionedBy {
          firstName
          lastName
        }
        id
        parentEntityId
        parentEntityType
        proposedValue
        rejectionReason
        sources {
          source
          sourceId
        }
        status
        subjectType
        targetAttribute
        targetEntityId
        targetEntityType
      }
    }
  }
`;
